import React, { useEffect } from "react";

const ImageInImage = ({ content }) => {
  useEffect(() => {
    setTimeout(() => {
      if (document.getElementById("image-in-image-1")) {
        document.getElementById("image-in-image-1").classList.add("img-fade-1");
      }
      if (document.getElementById("image-in-image-2")) {
        document.getElementById("image-in-image-2").classList.add("img-fade-2");
      }
    }, 100);
    return () => {
      if (document.getElementById("image-in-image-1")) {
        document.getElementById("image-in-image-1").style.opacity = "0";
        document
          .getElementById("image-in-image-1")
          .classList.remove("img-fade-1");
      }
      if (document.getElementById("image-in-image-2")) {
        document.getElementById("image-in-image-2").style.opacity = "0";
        document
          .getElementById("image-in-image-2")
          .classList.remove("img-fade-2");
      }
    };
  }, [content]);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        margin: content.margin,
      }}
    >
      <img
        id="image-in-image-1"
        style={{
          position: "absolute",
          ...content.outerImgStyles,
        }}
        src={content.src1}
      />
      <img
        id="image-in-image-2"
        style={{
          position: "absolute",
          ...content.innerImgStyle,
        }}
        src={content.src2}
      />
    </div>
  );
};

export default ImageInImage;
